import { createFileRoute } from '@tanstack/react-router';
import { defaultOrganizationId } from '@nest/ids';
import { requirePermission } from '@/features/auth/access';
import { IndustriesPage } from '@/features/industry/list-page';
import { PlatformWorkspace } from '@/features/tenant/platform-workspace';

export const Route = createFileRoute('/_authenticated/operations/industries')({
  beforeLoad: ({ context, location }) => {
    if (context.session.session.activeOrganizationId !== defaultOrganizationId)
      return;
    return requirePermission(
      context.queryClient,
      location.href,
      'industries:read',
    );
  },
  component: IndustriesRoute,
});

function IndustriesRoute() {
  const { session } = Route.useRouteContext();
  return (
    <PlatformWorkspace session={session}>
      <IndustriesPage />
    </PlatformWorkspace>
  );
}
